export default __webpack_public_path__ + "static/media/gob_about_slide_2.a6ac4d56.png";